import { type ComputedRef, type Ref, computed, ref, watch } from 'vue'
import {
  getChatNotificationsEnabled,
  setChatNotificationsEnabled,
} from '@/modules/chat-matrix-fast/utils/chatNotifications'

export function useActiveChatNotifications(
  activeChatId: () => number | string | null | undefined,
) {
  const isChatNotificationsEnabled = ref(true)

  const loadChatNotifications = () => {
    const chatId = activeChatId()
    isChatNotificationsEnabled.value = chatId
      ? getChatNotificationsEnabled(chatId)
      : true
  }

  watch(activeChatId, loadChatNotifications, { immediate: true })

  watch(isChatNotificationsEnabled, enabled => {
    const chatId = activeChatId()
    if (chatId) {
      setChatNotificationsEnabled(chatId, enabled)
    }
  })

  const notificationButtonIcon = computed(() =>
    isChatNotificationsEnabled.value ? 'ri-volume-up-line' : 'ri-volume-mute-line',
  )

  return {
    isChatNotificationsEnabled,
    notificationButtonIcon,
  }
}

export function buildNotificationsMenuItem(
  isEnabled: Ref<boolean>,
  icon: ComputedRef<string>,
) {
  return {
    type: 'switcher' as const,
    title: 'Уведомления',
    value: 'Mute Notifications',
    prependIcon: () => icon.value,
    model: isEnabled,
  }
}
